import { MyPudoHomeProps } from './my-pudo-home.component';

interface ViewProps {}

const useMyPudoHome = (props: MyPudoHomeProps): ViewProps => {
    return {};
};

export default useMyPudoHome;
